import * as React from 'react';
import type { CallToActionProps } from 'core/components/CallToAction/CallToAction';
import CallToAction from 'core/components/CallToAction';
import { GatsbyLinkProps, Link } from 'gatsby';
import { BOOKING_URL } from 'core/constants';
import useTrackBookingStarted from 'analytics/ttd/hooks/useTrackBookingStarted';
import type { PreselectBookingData } from '../../lib/types';
import { getBookingStepUrl } from '../../lib/utils';

export type StartBookingButtonProps = Partial<CallToActionProps> &
    Omit<PreselectBookingData, 'date'> & {
        gaEventName?: string;
        appointmentReasonId?: string;
    };

export default function StartBookingButton({
    locationId,
    citySlug,
    locationSlug,
    gaEventName,
    appointmentReasonId,
    ...props
}: StartBookingButtonProps) {
    const to = React.useMemo(() => {
        const searchParams = new URLSearchParams();
        if (appointmentReasonId) {
            searchParams.set('appointmentReasonId', appointmentReasonId);
        }

        const search = searchParams.toString();
        const searchSuffix = search ? `?${search}` : '';

        switch (true) {
            case !!locationSlug && !!citySlug:
                return `${getBookingStepUrl('date', citySlug, locationSlug)}${searchSuffix}`;
            case !!citySlug:
                return `${getBookingStepUrl('location', citySlug, '')}${searchSuffix}`;
            default:
                return `/${BOOKING_URL}/city${searchSuffix}`;
        }
    }, [citySlug, locationSlug, appointmentReasonId]);
    const trackBookingStarted = useTrackBookingStarted(gaEventName);

    return (
        <CallToAction
            Component={Link}
            state={{ locationId }}
            {...(props as GatsbyLinkProps<unknown>)}
            to={to}
            onClick={trackBookingStarted}
        />
    );
}
